module.exports = __webpack_public_path__ + "img/add-image8.8231e0f3.png";